var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalDistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 44,
    r: 38,
    fill: "#5D68B0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0001,
    cy: 44,
    r: 31.2444,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.9999,
    cy: 44,
    r: 23.6444,
    fill: "#5D68B0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 44,
    r: 16.0444,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.9999,
    cy: 44,
    r: 7.6,
    fill: "#5D68B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2222 83.6889L45.9999 50.7556L61.1999 83.6889H31.2222Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9222 43.5859C46.062 43.6163 46.2067 43.6163 46.3464 43.5859L47.6613 43.3005C48.0457 43.2171 48.4335 43.4264 48.5748 43.7935L48.7208 44.173C48.7262 44.1868 48.7381 44.1971 48.7527 44.2002C48.7793 44.206 48.7943 44.2343 48.7843 44.2596L48.7776 44.2765C48.7721 44.2904 48.772 44.3059 48.7774 44.3199L64.0544 84.0186C64.3065 84.6737 63.823 85.3778 63.1211 85.3778H60.1943C59.7822 85.3778 59.4122 85.1249 59.2626 84.7409L47.0361 53.3726C46.7062 52.526 45.5095 52.5226 45.1748 53.3673L32.7386 84.7463C32.5876 85.1275 32.2191 85.3778 31.809 85.3778L28.4778 85.3778C27.7699 85.3778 27.2861 84.6625 27.5497 84.0055L43.4838 44.2913C43.488 44.281 43.488 44.2694 43.484 44.2591L43.4795 44.2476C43.4721 44.2285 43.4835 44.2073 43.5035 44.203C43.5143 44.2006 43.5232 44.1931 43.5273 44.1828L43.6823 43.7966C43.8308 43.4265 44.2247 43.2175 44.6145 43.3021L45.9222 43.5859Z",
    fill: "#5D68B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalDistribution);
export default __webpack_public_path__ + "static/media/global-distribution.47ae7965b9778e6ce5abfa6ed8c8d3a1.svg";
export { ForwardRef as ReactComponent };